// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".8a49742d79c0c4e622fd7e59151d31d0.js";
};